/** Internal type. DO NOT USE DIRECTLY. */
import { gql } from "@apollo/client"
import * as Apollo from "@apollo/client"

import * as Types from "../../../shared/types/__generated__/graphql"
import { ProjectFragmentDoc } from "./fragments.generated"

type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never
    }

const defaultOptions = {} as const
export type ChangeProjectOwnerInput = {
  id: string
  team: string
}

export type CreateProjectInput = {
  description?: string | null
  id?: string | null
  inflationSurcharge?: number | null
  position?: number | null
  priceList?: string | null
  title: string
  ui?: ProjectUiInput | null
}

export type JsonapiRelationshipData = {
  id: string
  type: string
}

export type ProjectUiInput = {
  color?: string | null
}

export type UpdateProjectInput = {
  description?: string | null
  id: string
  inflationSurcharge?: number | null
  position?: number | null
  priceList?: string | null
  title?: string | null
  ui?: ProjectUiInput | null
}

export type CreateProjectMutationVariables = Exact<{
  input: Types.CreateProjectInput
}>

export type CreateProjectMutation = {
  __typename: "Mutation"
  project: {
    __typename: "Project"
    id: string
    title: string
    description?: string | null
    position: number
    priceList?: string | null
    inflationSurcharge?: number | null
    createdAt: string
    updatedAt: string
    lastChanged?: string | null
    hasClarificationRequest?: boolean | null
    ui?: { __typename: "ProjectUI"; color?: string | null } | null
    lastChangedBy?: {
      __typename: "User"
      id: string
      name?: string | null
      email: string
      createdAt: string
      updatedAt: string
    } | null
    phase?: {
      __typename: "ProjectPhase"
      id: string
      value: string
      label: string
    } | null
    team?: { __typename: "ProjectTeamID"; id: string } | null
  }
}

export type UpdateProjectMutationVariables = Exact<{
  id: string
  input: Types.UpdateProjectInput
}>

export type UpdateProjectMutation = {
  __typename: "Mutation"
  project: {
    __typename: "Project"
    id: string
    title: string
    description?: string | null
    position: number
    priceList?: string | null
    inflationSurcharge?: number | null
    createdAt: string
    updatedAt: string
    lastChanged?: string | null
    hasClarificationRequest?: boolean | null
    ui?: { __typename: "ProjectUI"; color?: string | null } | null
    lastChangedBy?: {
      __typename: "User"
      id: string
      name?: string | null
      email: string
      createdAt: string
      updatedAt: string
    } | null
    phase?: {
      __typename: "ProjectPhase"
      id: string
      value: string
      label: string
    } | null
    team?: { __typename: "ProjectTeamID"; id: string } | null
  }
}

export type ChangeProjectOwnerMutationVariables = Exact<{
  id: string
  input: Types.ChangeProjectOwnerInput
}>

export type ChangeProjectOwnerMutation = {
  __typename: "Mutation"
  project: {
    __typename: "Project"
    id: string
    title: string
    description?: string | null
    position: number
    priceList?: string | null
    inflationSurcharge?: number | null
    createdAt: string
    updatedAt: string
    lastChanged?: string | null
    hasClarificationRequest?: boolean | null
    ui?: { __typename: "ProjectUI"; color?: string | null } | null
    lastChangedBy?: {
      __typename: "User"
      id: string
      name?: string | null
      email: string
      createdAt: string
      updatedAt: string
    } | null
    phase?: {
      __typename: "ProjectPhase"
      id: string
      value: string
      label: string
    } | null
    team?: { __typename: "ProjectTeamID"; id: string } | null
  }
}

export type DeleteProjectChildrenMutationVariables = Exact<{
  id: string
  input: Array<Types.JsonapiRelationshipData> | Types.JsonapiRelationshipData
}>

export type DeleteProjectChildrenMutation = {
  __typename: "Mutation"
  deleteProjectChildren: { __typename: "DeleteResponse"; success: boolean }
}

export type DeleteProjectMutationVariables = Exact<{
  id: string
}>

export type DeleteProjectMutation = {
  __typename: "Mutation"
  project: { __typename: "DeleteResponse"; success: boolean }
}

export const CreateProjectDocument = gql`
  mutation CreateProject($input: CreateProjectInput!) {
    project: createProject(input: $input)
      @rest(
        type: "Project"
        endpoint: "project"
        method: "POST"
        path: "/project-list/projects"
        bodySerializer: "project"
      ) {
      ...Project
    }
  }
  ${ProjectFragmentDoc}
`
export type CreateProjectMutationFn = Apollo.MutationFunction<
  CreateProjectMutation,
  CreateProjectMutationVariables
>

/**
 * __useCreateProjectMutation__
 *
 * To run a mutation, you first call `useCreateProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectMutation, { data, loading, error }] = useCreateProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProjectMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateProjectMutation,
    CreateProjectMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateProjectMutation,
    CreateProjectMutationVariables
  >(CreateProjectDocument, options)
}
export type CreateProjectMutationHookResult = ReturnType<
  typeof useCreateProjectMutation
>
export type CreateProjectMutationResult =
  Apollo.MutationResult<CreateProjectMutation>
export type CreateProjectMutationOptions = Apollo.BaseMutationOptions<
  CreateProjectMutation,
  CreateProjectMutationVariables
>
export const UpdateProjectDocument = gql`
  mutation UpdateProject($id: ID!, $input: UpdateProjectInput!) {
    project: updateProject(id: $id, input: $input)
      @rest(
        type: "Project"
        endpoint: "project"
        method: "PUT"
        path: "/project-list/projects/{args.id}"
        bodySerializer: "project"
      ) {
      ...Project
    }
  }
  ${ProjectFragmentDoc}
`
export type UpdateProjectMutationFn = Apollo.MutationFunction<
  UpdateProjectMutation,
  UpdateProjectMutationVariables
>

/**
 * __useUpdateProjectMutation__
 *
 * To run a mutation, you first call `useUpdateProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectMutation, { data, loading, error }] = useUpdateProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProjectMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateProjectMutation,
    UpdateProjectMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateProjectMutation,
    UpdateProjectMutationVariables
  >(UpdateProjectDocument, options)
}
export type UpdateProjectMutationHookResult = ReturnType<
  typeof useUpdateProjectMutation
>
export type UpdateProjectMutationResult =
  Apollo.MutationResult<UpdateProjectMutation>
export type UpdateProjectMutationOptions = Apollo.BaseMutationOptions<
  UpdateProjectMutation,
  UpdateProjectMutationVariables
>
export const ChangeProjectOwnerDocument = gql`
  mutation ChangeProjectOwner($id: ID!, $input: ChangeProjectOwnerInput!) {
    project: changeProjectOwner(id: $id, input: $input)
      @rest(
        type: "Project"
        endpoint: "project"
        method: "PUT"
        path: "/project-list/projects/{args.id}/change-owner"
        bodySerializer: "project"
      ) {
      ...Project
    }
  }
  ${ProjectFragmentDoc}
`
export type ChangeProjectOwnerMutationFn = Apollo.MutationFunction<
  ChangeProjectOwnerMutation,
  ChangeProjectOwnerMutationVariables
>

/**
 * __useChangeProjectOwnerMutation__
 *
 * To run a mutation, you first call `useChangeProjectOwnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeProjectOwnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeProjectOwnerMutation, { data, loading, error }] = useChangeProjectOwnerMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeProjectOwnerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ChangeProjectOwnerMutation,
    ChangeProjectOwnerMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ChangeProjectOwnerMutation,
    ChangeProjectOwnerMutationVariables
  >(ChangeProjectOwnerDocument, options)
}
export type ChangeProjectOwnerMutationHookResult = ReturnType<
  typeof useChangeProjectOwnerMutation
>
export type ChangeProjectOwnerMutationResult =
  Apollo.MutationResult<ChangeProjectOwnerMutation>
export type ChangeProjectOwnerMutationOptions = Apollo.BaseMutationOptions<
  ChangeProjectOwnerMutation,
  ChangeProjectOwnerMutationVariables
>
export const DeleteProjectChildrenDocument = gql`
  mutation DeleteProjectChildren(
    $id: ID!
    $input: [JSONAPIRelationshipData!]!
  ) {
    deleteProjectChildren: deleteProjectChildren(id: $id, input: $input)
      @rest(
        type: "DeleteResponse"
        method: "PATCH"
        path: "/project-list/projects/{args.id}/children"
        bodySerializer: "deleteProjectChildren"
      ) {
      success
    }
  }
`
export type DeleteProjectChildrenMutationFn = Apollo.MutationFunction<
  DeleteProjectChildrenMutation,
  DeleteProjectChildrenMutationVariables
>

/**
 * __useDeleteProjectChildrenMutation__
 *
 * To run a mutation, you first call `useDeleteProjectChildrenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectChildrenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectChildrenMutation, { data, loading, error }] = useDeleteProjectChildrenMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteProjectChildrenMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteProjectChildrenMutation,
    DeleteProjectChildrenMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    DeleteProjectChildrenMutation,
    DeleteProjectChildrenMutationVariables
  >(DeleteProjectChildrenDocument, options)
}
export type DeleteProjectChildrenMutationHookResult = ReturnType<
  typeof useDeleteProjectChildrenMutation
>
export type DeleteProjectChildrenMutationResult =
  Apollo.MutationResult<DeleteProjectChildrenMutation>
export type DeleteProjectChildrenMutationOptions = Apollo.BaseMutationOptions<
  DeleteProjectChildrenMutation,
  DeleteProjectChildrenMutationVariables
>
export const DeleteProjectDocument = gql`
  mutation DeleteProject($id: ID!) {
    project: deleteProject(id: $id)
      @rest(
        type: "DeleteResponse"
        endpoint: "delete"
        method: "DELETE"
        path: "/project-list/projects/{args.id}"
      ) {
      success
    }
  }
`
export type DeleteProjectMutationFn = Apollo.MutationFunction<
  DeleteProjectMutation,
  DeleteProjectMutationVariables
>

/**
 * __useDeleteProjectMutation__
 *
 * To run a mutation, you first call `useDeleteProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectMutation, { data, loading, error }] = useDeleteProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProjectMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteProjectMutation,
    DeleteProjectMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    DeleteProjectMutation,
    DeleteProjectMutationVariables
  >(DeleteProjectDocument, options)
}
export type DeleteProjectMutationHookResult = ReturnType<
  typeof useDeleteProjectMutation
>
export type DeleteProjectMutationResult =
  Apollo.MutationResult<DeleteProjectMutation>
export type DeleteProjectMutationOptions = Apollo.BaseMutationOptions<
  DeleteProjectMutation,
  DeleteProjectMutationVariables
>
